import API from '../interceptors/Api';

const BASE_URL = '/committed-applications';

export const getCommittedApplications = (params) => API.get(BASE_URL, {
  params,
});

export const getCommittedApplicationsAggregations = (params) => API.get(`${BASE_URL}/aggregations`, {
  params,
});

export const getCommittedApplicationsExpired = (params) => API.get(`${BASE_URL}/expirations`, {
  params,
});

export const getCommittedApplicationsToExpire = (params) => API.get(`${BASE_URL}/to-expire`, { params });
